<template>
  <!--Legende -->
  <div
    class="z-50 p-0 transition-all duration-500 rounded-l-none shadow-lg  bg-base-100 card"
    :class="{
      'translate-x-[calc(-100%+2rem)] h-40 ': !openLegend,
      'translate-x-0 h-auto ': openLegend,
    }"
  >
    <div
      :class="{
        'opacity-0 pointer-events-none': openLegend,
        'opacity-100 pointer-events-auto': !openLegend,
      }"
      @click="openLegend = !openLegend"
      class="absolute right-0 flex items-center justify-between h-full py-4 text-2xl font-bold rotate-180  text-secondary-content bg-secondary"
      style="writing-mode: vertical-rl; text-orientation: mixed"
    >
      <span>Filtres</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6 scale-100 rotate-90 cursor-pointer  animate-pulse hover:scale-110 hover:animate-none"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
        />
      </svg>
    </div>
    <div class="p-0 card-body">
      <div
        :class="{
          'opacity-0': !openLegend,
          'opacity-100': openLegend,
        }"
        @click="openLegend = !openLegend"
        class="flex items-center justify-between px-2 py-1 text-2xl font-bold  gap-x-4 card-title bg-secondary text-secondary-content"
      >
        <span>Filtre</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 scale-100 rotate-90 cursor-pointer  animate-pulse hover:scale-110 hover:animate-none"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
          />
        </svg>
      </div>

      <div class="px-2 overflow-auto max-h-64">
        <template v-for="(value, key) of filterData" :key="key">
          <h1 class="text-xl font-bold text-secondary">Par {{ key }}</h1>
          <template v-for="(el, index) of value" :key="index">
            <div
              @click="updateFilter(key, el.id)"
              class="p-2 mt-1 mb-2 text-xs border-l-4 cursor-pointer  rounded-l-xl hover:font-bold hover:border-l-8 ring-1 animate__animated animate__fadeInDown"
              :class="{
                'text-primary border-primary':
                  filterProperty[key].indexOf(el.id) != -1,
              }"
            >
              <span>{{ el.value }}</span>
            </div>
          </template>
        </template>

        <template v-if="relations">
          <h1 class="text-xl font-bold text-secondary">Par Relation</h1>
          <template v-for="(rel, index) of relations" :key="index">
            <div
              @click="updateFilter('relations', rel.id)"
              class="p-2 mt-1 mb-2 text-xs border-l-4 cursor-pointer  rounded-l-xl hover:font-bold hover:border-l-8 ring-1 animate__animated animate__fadeInDown"
              :class="{
                'text-primary border-primary':
                  filterProperty.relations?.indexOf(rel.id) != -1,
              }"
            >
              <span>{{ rel.text }}</span>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
  <!-- Fin  Legende -->
</template>

<script>
export default {
  name: "FiltreAPP",
  props: {
    items: Array,
    relations: Array,
  },
  mounted() {
    this.filterData.influence = [
      ...new Set(this.items.map((x) => x.influence)),
    ];
    this.filterProperty.influence = this.filterData.influence.map((x) => x.id);
    this.filterData.type = [...new Set(this.items.map((x) => x.type.id))].map(
      (x) => this.items.filter((y) => y.type.id == x)[0].type
    );
    this.filterProperty.type = this.filterData.type.map((x) => x.id);
    this.filterData.implication = [
      ...new Set(this.items.map((x) => x.implication)),
    ];
    this.filterProperty.implication = this.filterData.implication.map(
      (x) => x.id
    );

    if (this.relations) {
      this.filterProperty.relations = this.relations.map((x) => x.id);
    }
  },
  data() {
    return {
      openLegend: true,
      filterData: {},
      filterProperty: {},
    };
  },

  methods: {
    updateFilter(key, value) {
      var index = this.filterProperty[key].indexOf(value);

      //If present we remove
      if (index != -1) {
        this.filterProperty[key] = this.filterProperty[key].filter(
          (x) => x != value
        );
      } else {
        this.filterProperty[key] = [...this.filterProperty[key], value];
      }

      this.$emit("filterupdated", this.filterProperty);
    },
  },
};
</script>

<style>
</style>
